import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { fetchDoctorProfile, registerUser, updateDoctorDetails, updateUserDetais } from "../../constants/ApiConstants";
import { Link, redirect, useNavigate } from "react-router-dom";
import SelectField from "../../components/SelectField";
import SelectField2 from "../../components/SelectField2";
import { countries } from "../../utils/countries";
import MobileNumberWithCountryCode from "../../components/MobileNumberWithCountryCode";
import DatePicker from "react-datepicker";
import { getYYYYmmddFromDate } from "../../utils/utils";
import { updateDoctorData, updateUserData } from "../../store/appSlice";
import TextAreaField from "../../components/TextAreaField";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";

export default function DoctorProfileSetupTwo() {
  pageTitle("Complete Profile Registration");

  const [loading, setLoading] = useState(false);
  const doctorData = useSelector((state) => state.appSlice.doctorData);
  const [about, setAbout] = useState("");
  const [educationalJourney, setEducationalJourney] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [doctorDetail, setDoctorDetail] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);

    axiosInstance
      .post(fetchDoctorProfile, { doctor_id: doctorData?.id })
      .then((res) => {
        setDoctorDetail(res?.data?.data);
        setAbout(res?.data?.data?.about_youself || "");
        setEducationalJourney(res?.data?.data.educational_journey || "");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmitClick = async () => {
    if (about === "") {
      toast.error("About yourself is required.");
      return;
    }

    if (educationalJourney === "") {
      toast.error("Educational Journey is required");
      return;
    }
    const payload = {
      doctor_id: doctorData?.id,
      about_youself: about,
      educational_journey: educationalJourney,
    };
    try {
      setLoading(true);
      const response = await axiosInstance.post(updateDoctorDetails, {
        ...payload,
      });
      if (response.data?.status) {
        toast.success("Doctor details has been updated.");
        dispatch(updateDoctorData(response?.data?.data));
        navigatePage();
      } else {
        toast.error(response.data?.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      // toast.error(err.response.data?.message);
      setLoading(false);
    }
  };

  function navigatePage() {
    navigate("/doctor-profile");
  }

  return (
    <Wrapper>
      <Section topMd={60} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 gap-1 justify-content-center">
          <div className="col-12 col-md-4 g-2 mx-auto">
            <CommonMobileHeader title={"Complete Registration"} />
            <p className="fs-md text-grey2 p-2"></p>
            <TextAreaField rows={3} label="About Yourself" sublabel="Explain about yourself briefly" placeholder="Enter here..." inputType={"text"} value={about} onChange={(e) => setAbout(e.target.value)} />
            <TextAreaField rows={3} label="Your Educational Journey" sublabel="Explain briefly for better idea" placeholder="Enter here..." inputType={"text"} value={educationalJourney} onChange={(e) => setEducationalJourney(e.target.value)} />
            <SecondaryButton title={"Submit"} className={"mt-3"} onClick={handleSubmitClick} loading={submitting} />
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
